export const SendIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 14"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.59083 1.71245L2.37998 6.25004H7.24916C7.66337 6.25004 7.99916 6.58582 7.99916 7.00004C7.99916 7.41425 7.66337 7.75004 7.24916 7.75004H2.37998L1.59083 12.2876L13.9285 7.00004L1.59083 1.71245ZM0.987893 7.00004L0.0628203 1.68087C-0.0119643 1.25086 0.127178 0.811352 0.435807 0.502722C0.823592 0.114942 1.40841 0.00231168 1.91248 0.218342L15.3148 5.9622C15.7299 6.14013 15.9991 6.54835 15.9991 7.00004C15.9991 7.45172 15.7299 7.85995 15.3148 8.03788L1.91248 13.7817C1.40841 13.9978 0.823592 13.8851 0.435807 13.4974C0.127178 13.1887 -0.0119645 12.7492 0.0628203 12.3192L0.987893 7.00004Z"
        fill="currentColor"
      />
    </svg>
  )
}
